import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { IntersectionOptions, InViewHookResponse, useInView as useInViewHook } from 'react-intersection-observer';

interface InViewContext {
  isInView: boolean;
  hasBeenInView: boolean;
}

export const InViewContext = createContext<InViewContext | undefined>(undefined);

export const useIsOnScreen = () => {
  return useContext(InViewContext);
};

interface UseInViewResponse {
  isInView: boolean;
  hasBeenInView: boolean;
  ref: InViewHookResponse['ref'];
}

export const useInView: (options: IntersectionOptions & { log?: boolean }) => UseInViewResponse = (options) => {
  const { inView: isInView, ref } = useInViewHook(options);
  const [hasBeenInView, setHasBeenInView] = useState<boolean>(options.initialInView || false);

  useEffect(() => {
    if (isInView === true && hasBeenInView === false) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setHasBeenInView(true);
    }
  }, [isInView, hasBeenInView, setHasBeenInView]);

  const response = useMemo(
    () => ({
      isInView,
      ref,
      hasBeenInView,
    }),
    [isInView, ref, hasBeenInView]
  );
  return response;
};
